import React from 'react';
import { Description, PictureAsPdf, Image, Article } from '@mui/icons-material';

export const formatDate = (dateString?: string | null): string => {
  if (!dateString) return 'Unknown';
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getFileIcon = (extension: string): React.ReactElement => {
  const ext = extension.toLowerCase();
  if (ext === '.pdf') return <PictureAsPdf sx={{ fontSize: 48, color: '#dc2626' }} />;
  if (['.jpg', '.jpeg', '.png', '.gif', '.bmp'].includes(ext))
    return <Image sx={{ fontSize: 48, color: '#3b82f6' }} />;
  if (['.doc', '.docx', '.txt'].includes(ext))
    return <Article sx={{ fontSize: 48, color: '#2563eb' }} />;
  return <Description sx={{ fontSize: 48, color: '#64748b' }} />;
};

export const getFileTypeLabel = (extension: string): string => {
  const ext = extension.toLowerCase();
  if (ext === '.pdf') return 'PDF Document';
  if (['.jpg', '.jpeg', '.png', '.gif', '.bmp'].includes(ext)) return 'Image';
  if (['.doc', '.docx'].includes(ext)) return 'Word Document';
  if (['.xls', '.xlsx'].includes(ext)) return 'Excel Spreadsheet';
  if (ext === '.txt') return 'Text File';
  return 'Document';
};
